export enum AccountTypeEnum {
    local = 'local',
    bank = 'bank',
    pos = 'pos',
    sys = 'sys',
}
